import React from 'react';
import TweetComposerContent from './TweetComposerContent';
export default function StandardTweetComposer(param) {
    var user = param.user, placeholder = param.placeholder, autoFocus = param.autoFocus, isOpen = param.isOpen, mode = param.mode, referenceTweet = param.referenceTweet, onSubmitAction = param.onSubmitAction, store = param.store, externalSetImages = param.externalSetImages;
    return /*#__PURE__*/ React.createElement(TweetComposerContent, {
        showProfileImage: true,
        user: user,
        placeholder: placeholder,
        autoFocus: autoFocus,
        isOpen: isOpen,
        mode: mode,
        referenceTweet: referenceTweet,
        onSubmitAction: onSubmitAction,
        store: store,
        externalSetImages: externalSetImages
    });
}
